export function getIsSeatAvailableByCombineWith(activeDoubleSeats) {
    return (seat) => {
        if (!activeDoubleSeats) {
            return seat;
        }
        return Object.assign(Object.assign({}, seat), { isAvailable: seat.isAvailable && !!Object.keys(seat.combinedWith).length });
    };
}
